const state = {
    priceList: null
};

const getters = {
    priceList: (state) => state.priceList,
};

const mutations = {
    setPointPriceList(state, priceList) {
        state.priceList = priceList;
    },
};

const actions = {
    updatePointPriceList({commit}, priceList) {
        commit('setPointPriceList', priceList);
    }
};

export default {
    namespaced: true, // 使用命名空间
    state,
    getters,
    mutations,
    actions,
};
